module.exports = __webpack_public_path__ + "img/yonghu.ea954c7f.png";